import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestApprovePayment(params) {
  return fetch.patch(`${BASE_URL}/api/app/payments/approve`, {
    ...params,
  });
}
export function requestApprovePaymentList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/payments`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/payments?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}

export function downloadPaymentPDF(body) {
  return fetch.post(
    `${BASE_URL}/api/app/payments/generatePaymentReceipt`,
    body
  );
}
